module.exports = __webpack_public_path__ + "img/category.57e27c99.svg";